import React from "react";

const SvgComponent = props => (
  <svg viewBox="0 0 2048 2048" width="1em" height="1em" {...props}>
    <path
      className="OfficeIconColors_HighContrast"
      d="M307 0v512h-81V99q-41 29-105 46V76q24-7 44-15 19-9 37-18t36-19q17-11 35-24m145 1229H102v-39q0-45 26-86t93-94q31-25 52-43 20-19 33-35 12-17 17-32 5-16 5-36 0-38-22-59-23-21-60-21-65 0-125 57v-78q31-23 63-34 32-12 77-12 69 0 110 36 40 35 40 102 0 32-6 57-7 24-24 47t-45 49q-29 25-72 59-38 30-55 50-18 20-18 38v4h227m-11 636q0 68-49 110-50 41-135 41-32 0-66-8-35-8-52-19v-79q22 18 54 29t64 11q47 0 74-22t27-60q0-83-125-83h-43v-66h41q51 0 81-19t30-59q0-35-23-53-24-19-63-19-54 0-98 35v-73q22-12 53-19 31-8 66-8 63 0 105 32 41 31 41 88 0 48-26 80-26 31-72 43v2q54 6 85 38 31 31 31 78m1539-771H717V922h1229m0-717v102H717V205m1229 1433v103H717v-103z"
    />
    <path
      className="OfficeIconColors_m24"
      d="M307 0v512h-81V99q-41 29-105 46V76q24-7 44-15 19-9 37-18t36-19q17-11 35-24m145 1229H102v-39q0-45 26-86t93-94q31-25 52-43 20-19 33-35 12-17 17-32 5-16 5-36 0-38-22-59-23-21-60-21-65 0-125 57v-78q31-23 63-34 32-12 77-12 69 0 110 36 40 35 40 102 0 32-6 57-7 24-24 47t-45 49q-29 25-72 59-38 30-55 50-18 20-18 38v4h227m-11 636q0 68-49 110-50 41-135 41-32 0-66-8-35-8-52-19v-79q22 18 54 29t64 11q47 0 74-22t27-60q0-83-125-83h-43v-66h41q51 0 81-19t30-59q0-35-23-53-24-19-63-19-54 0-98 35v-73q22-12 53-19 31-8 66-8 63 0 105 32 41 31 41 88 0 48-26 80-26 31-72 43v2q54 6 85 38 31 31 31 78z"
    />
    <path
      className="OfficeIconColors_m22"
      d="M1946 1024H717V922h1229m0-717v102H717V205m1229 1433v103H717v-103z"
    />
  </svg>
);

export default SvgComponent;
